import { useMemo } from 'react';

interface Warning {
  id: string | number;
  warning: string;
  priority: number | string;
}

interface NPSDWarningsDisplayProps {
  warnings: Warning[];
}

export function NPSDWarningsDisplay({ warnings = [] }: NPSDWarningsDisplayProps) {
  const highPriorityWarnings = useMemo(() => {
    return warnings.filter((w) => w.priority === 300 || w.priority === '300');
  }, [warnings]);

  const mediumPriorityWarnings = useMemo(() => {
    return warnings.filter((w) => w.priority === 200 || w.priority === '200');
  }, [warnings]);

  const lowPriorityWarnings = useMemo(() => {
    return warnings.filter((w) => w.priority === 100 || w.priority === '100');
  }, [warnings]);

  const hasWarnings = warnings && warnings.length > 0;

  if (!hasWarnings) return null;

  return (
    <div className="npsd-warnings-display">
      {highPriorityWarnings.map((warning) => (
        <span key={'high-' + warning.id} className="warning-badge warning-high">
          <i className="fas fa-exclamation-triangle" style={{ marginRight: '6px' }}></i>
          {warning.warning}
        </span>
      ))}
      {mediumPriorityWarnings.map((warning) => (
        <span key={'medium-' + warning.id} className="warning-badge warning-medium">
          <i className="fas fa-exclamation-circle" style={{ marginRight: '6px' }}></i>
          {warning.warning}
        </span>
      ))}
      {lowPriorityWarnings.map((warning) => (
        <span key={'low-' + warning.id} className="warning-badge warning-low">
          <i className="fas fa-info-circle" style={{ marginRight: '6px' }}></i>
          {warning.warning}
        </span>
      ))}
    </div>
  );
}

(window as any).NPSDWarningsDisplayReact = NPSDWarningsDisplay;
